import * as Api from '@ViewModels';

/**
 * Check if a BrandingSettings object has any meaningful data configured.
 * Used to gate branding UI — colors, font, images, or a brand description
 * all count as "configured".
 */
export function hasBrandingSettings(settings: Api.BrandingSettings | null | undefined): boolean {
	if (!settings) return false;
	return !!(
		settings.primaryColor ||
		settings.secondaryColor ||
		settings.accentColor ||
		(settings.additionalColors && Object.keys(settings.additionalColors).length > 0) ||
		settings.font?.fontName ||
		settings.images?.length ||
		settings.brandDescription
	);
}
